/* JL14 Trust/Reviews banner — VAR-336
   Carousel + sticky-header offset. Ported from Intelligems experiment 8c5e9c93 (Variant B). */
(function () {
  var PAUSE =
    '<svg width="13" height="13" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="5" y="3.5" width="1.5" height="10" fill="currentColor"></rect><rect x="9.5" y="3.5" width="1.5" height="10" fill="currentColor"></rect></svg>';
  var PLAY =
    '<svg width="13" height="13" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 3.304 13 8.5l-9 5.196V3.304Z" fill="currentColor"></path></svg>';

  // Measure the banner and expose its height so the sticky header can sit flush below it
  // (no overlap, no gap) at any breakpoint / wrap state — VAR-336 requirement 4.
  function setHeightVar(root) {
    var banner = root.querySelector('.jl14-banner');
    var h = banner ? banner.offsetHeight : 45;
    document.documentElement.style.setProperty('--announcement-bar-height', h + 'px');
  }

  function init(root) {
    if (!root || root.dataset.jl14Init === '1') return;
    root.dataset.jl14Init = '1';

    var slides = [].slice.call(root.querySelectorAll('.jl14-slide'));
    var n = slides.length;
    var i = 0;
    var playing = true;
    var timer = null;
    var interval = parseInt(root.getAttribute('data-autoplay'), 10) || 3850;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) playing = false;

    function render() {
      for (var k = 0; k < n; k++) {
        slides[k].classList.toggle('is-active', k === i);
      }
    }
    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }
    function start() {
      stop();
      if (!playing || n < 2) return;
      timer = setInterval(function () {
        i = (i + 1) % n;
        render();
      }, interval);
    }
    function go(d) {
      i = ((i + d) % n + n) % n;
      render();
      if (playing) start();
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-act]');
      if (!b) return;
      var a = b.getAttribute('data-act');
      if (a === 'prev') {
        go(-1);
      } else if (a === 'next') {
        go(1);
      } else if (a === 'toggle') {
        playing = !playing;
        b.innerHTML = playing ? PAUSE : PLAY;
        b.setAttribute('aria-label', playing ? 'Pause slideshow' : 'Play slideshow');
        if (playing) {
          start();
        } else {
          stop();
        }
      } else if (a === 'dismiss') {
        stop();
        root.style.display = 'none';
        document.documentElement.style.setProperty('--announcement-bar-height', '0px');
      }
    });

    render();
    start();
    setHeightVar(root);

    // Keep --announcement-bar-height in sync with the banner's real height so the sticky
    // header never overlaps or gaps — covers mobile wrapping, web-font load, orientation change.
    if (typeof ResizeObserver !== 'undefined') {
      var banner = root.querySelector('.jl14-banner');
      if (banner) {
        var ro = new ResizeObserver(function () {
          if (root.style.display !== 'none') setHeightVar(root);
        });
        ro.observe(banner);
      }
    }
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('.jl14');
    for (var i = 0; i < roots.length; i++) {
      init(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  window.addEventListener('resize', function () {
    var root = document.querySelector('.jl14');
    if (root && root.style.display !== 'none') setHeightVar(root);
  });

  // Re-init when re-rendered inside the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
